<template>
  <section class="section pt-0">
    <div class="container">
      <div class="title is-2 has-text-centered">
        {{ $t("professor portal") }}
      </div>
      <div class="message is-warning" v-if="!professor">
        <div class="message-body">
          <p class="has-text-centered">
            {{
              $t(
                "it seems you are no a registered professor, if you think this is a mistake please contact system administrator"
              )
            }}
          </p>
        </div>
      </div>
      <div v-else>
        <portal :professor="professor" />
      </div>
    </div>
  </section>
</template>

<script>
import { get, error_message } from "@/utils";
import Portal from "./Portal.vue";

export default {
  name: "ProfessorPortal",
  components: { Portal },
  data() {
    let v = this;
    return {
      professor: null,
    };
  },
  computed: {},
  methods: {
    refresh() {
      let v = this;
      v.$root.loader(true);
      get("/professor-portal/professor")
        .then((response) => {
          v.professor = response;
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
};
</script>

<style scoped></style>
